export default __webpack_public_path__ + "static/media/gautam.ee76f505.png";